import React from 'react';
import {X4Unit} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X4UnitBreadcrumbs extends React.Component<{ unit: X4Unit }> {
  render() {
    const {unit} = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={unit!.Level!.AgeCategory!.Language!.Name}
                               route={routes.x1language(unit!.Level!.AgeCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={unit!.Level!.AgeCategory!.Name}
                               route={routes.x2ageCategory(unit!.Level!.AgeCategoryId)}/>

            <TooltipBreadcrumb tooltip="Level"
                               label={unit!.Level!.Name}
                               route={routes.x3level(unit!.LevelId)}/>

            <TooltipBreadcrumb tooltip="Unit"
                               label={unit!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
